import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { RightService } from 'src/app/services/right.service';


@Injectable({
  providedIn: 'root'
})
export class DashboardGNLGuard implements CanActivate {

  state: RouterStateSnapshot;
  route: ActivatedRouteSnapshot;
  isRefreshPage = true;

  constructor(public router: Router,
    private rightService: RightService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.state = state;
      this.route = route;
    
      return this.rightService.canAccessSiteOperationManagement();

  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(route, state);
  }

}
